// extracted by mini-css-extract-plugin
export default {"secure":"secure-info_secure__77wGq","secureIcon":"secure-info_secureIcon__LLEQv"};